// Role helpers — single source of truth for the client's cosmetic role checks.
// (Real enforcement is server-side; these only drive nav visibility and labels.)
//
//   superadmin > admin > reseller
//   superadmin + admin  -> "admin or above": see all data, reach User Mgmt/Alerts
//   superadmin only     -> may create/manage admin & superadmin accounts + portal config
//
// `p` is the profile object from useAuth() (may be null while loading).

export const ROLE_LABELS = {
  superadmin: 'Super Admin',
  admin: 'Administrator',
  reseller: 'Reseller',
};

export const roleLabel = (role) => ROLE_LABELS[role] || role || '—';

export const isSuperadmin = (p) => p?.role === 'superadmin';

export const isAdminOrAbove = (p) => p?.role === 'admin' || p?.role === 'superadmin';

// Roles an actor may create/manage (used to gate the Add-account role picker and
// per-row actions in User Management).
export function manageableRoles(p) {
  if (isSuperadmin(p)) return ['superadmin', 'admin', 'reseller'];
  if (p?.role === 'admin') return ['reseller'];
  return [];
}

// Can this actor act on a target account with the given role?
export const canManage = (p, targetRole) => manageableRoles(p).includes(targetRole);
